import React from 'react';
import classnames from 'classnames';
import LogoEnSvg from './LogoEnSvg';
import LogoEsSvg from './LogoEsSvg';
import { getLanguage } from '@cmsgov/design-system';
export function Logo(props) {
  return /*#__PURE__*/React.createElement("span", {
    className: classnames('hc-c-logo', props.className)
  }, getLanguage() === 'es' ? /*#__PURE__*/React.createElement(LogoEsSvg, {
    titleId: props.titleId
  }) : /*#__PURE__*/React.createElement(LogoEnSvg, {
    titleId: props.titleId
  }));
}
export default Logo;